import { Injectable, inject } from '@angular/core';
import { WalletManager } from '../../managers/wallet.manager';
import { WalletTypeEnum } from '../../models/enums/wallet-type.enum';
import { KaspaComWebWalletService } from '../wallets/kaspa-com-web-wallet.service';
import type { WalletOperationBuildErrorRecovery } from './wallet-operation-build-error.util';

@Injectable({ providedIn: 'root' })
export class WalletOperationRecoveryService {
  private readonly walletManager = inject(WalletManager);
  private readonly kaspaComWebWalletService = inject(KaspaComWebWalletService);

  canRun(recovery: WalletOperationBuildErrorRecovery): boolean {
    return (
      recovery.kind === 'compound-kas-utxos' &&
      this.walletManager.signedWalletSignal()?.walletType ===
        WalletTypeEnum.KASPA_COM_WEB_WALLET
    );
  }

  run(recovery: WalletOperationBuildErrorRecovery): void {
    if (!this.canRun(recovery)) {
      return;
    }
    void this.kaspaComWebWalletService.setShowWallet(true, true);
  }
}
